import { render } from "./graficaBarras.vue?vue&type=template&id=cabd795c"
import script from "./graficaBarras.vue?vue&type=script&lang=js"
export * from "./graficaBarras.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__